import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { SurveyPage } from './components/pages/SurveyPage';
import { MentorSurveyPage } from './components/pages/MentorSurveyPage';
import { InvestorSurveyPage } from './components/pages/InvestorSurveyPage';
import { CofounderSurveyPage } from './components/pages/CofounderSurveyPage';
import './index.css';
ReactDOM.createRoot(document.getElementById('root')!).render(<React.StrictMode data-id="element-1405">
    <BrowserRouter data-id="element-1406">
      <Routes data-id="element-1407">
        <Route path="/" element={<App data-id="element-1409" />} data-id="element-1408" />
        <Route path="/solo-survey" element={<SurveyPage data-id="element-1411" />} data-id="element-1410" />
        <Route path="/mentor-survey" element={<MentorSurveyPage data-id="element-1413" />} data-id="element-1412" />
        <Route path="/investor-survey" element={<InvestorSurveyPage data-id="element-1415" />} data-id="element-1414" />
        <Route path="/cofounder-survey" element={<CofounderSurveyPage data-id="element-1417" />} data-id="element-1416" />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>);